//
export { default as Header } from '@/components/Header/locales.json';
export { default as TermsOfUse } from '@/components/TermsOfUse/locales.json';
export { default as Footer } from '@/components/Footer/locales.json';
export { default as Dashboard } from '@/modules/home/dashboard/locales.json';
export { default as Documents } from '@/modules/documents/locales.json';
export { default as NavigationDrawer } from '@/components/NavigationDrawer/locales.json';
export { default as DebtSolutionsCard } from '@/modules/home/dashboard/components/DebtSolutionsCard/locales.json';
export { default as ChildRider } from '@/modules/childrider/locales.json';
export { default as ChildRiderCRCStepAPersonalInfo } from '@/modules/childrider/components/CRCStepAPersonalInfo/locales.json';
export { default as ChildRiderCRCStepBSelectionOptions } from '@/modules/childrider/components/CRCStepBSelectionOptions/locales.json';
export { default as ChildRiderCRCStepCConfirmPayment } from '@/modules/childrider/components/CRCStepCConfirmPayment/locales.json';
export { default as ChildRiderCRCStepDEDelivery } from '@/modules/childrider/components/CRCStepDEDelivery/locales.json';
export { default as ChildRiderCRCStepEAcknowledge } from '@/modules/childrider/components/CRCStepEAcknowledge/locales.json';
export { default as PolicyMyRep } from '@/modules/myRep/locales.json';
export { default as ComponentLocales } from '@/components/locales.json';
export { default as Notfoundpage } from '@/components/404/locales.json';
export { default as Achievement } from '@/components/Achievement/locales.json';
export { default as ContactRep } from '@/components/ContactRep/locales.json';
// export {default as DialogPayment} from '@/components/DialogPayment/locales.json';
// export {default as DialogPdf} from '@/components/DialogPdf/locales.json';
// export {default as EComm} from '@/components/EComm/locales.json';
// export {default as FullScreenLoading} from '@/components/FullScreenLoading/locales.json';
export { default as GoPaperlessAction } from '@/components/GoPaperlessAction/locales.json';
export { default as InputsBankAccountNumber } from '@/components/Inputs/BankAccountNumber/locales.json';
export { default as InputsBankRoutingNumber } from '@/components/Inputs/BankRoutingNumber/locales.json';
export { default as InputsConfirmPassword } from '@/components/Inputs/ConfirmPassword/locales.json';
export { default as InputsDate } from '@/components/Inputs/Date/locales.json';
export { default as InputsMessage } from '@/components/Inputs/Message/locales.json';
export { default as InputsPassword } from '@/components/Inputs/Password/locales.json';
export { default as InputsReason } from '@/components/Inputs/Reason/locales.json';
export { default as InputsSubject } from '@/components/Inputs/Subject/locales.json';
export { default as InputsVerifyBankAccountNumber } from '@/components/Inputs/VerifyBankAccountNumber/locales.json';
export { default as LeftSidebarFinancialHouse } from '@/components/LeftSidebar/components/FinancialHouse/locales.json';
// export {default as LeftSidebarMySupport} from '@/components/LeftSidebar/components/MySupport/locales.json';
// export { default as LocaleToggle } from '@/components/LocaleToggle/locales.json';
export { default as NavigationConfirmation } from '@/components/NavigationConfirmation/locales.json';
// export {default as PasswordForm} from '@/components/PasswordForm/locales.json';
export { default as SessionDialog } from '@/components/SessionDialog/locales.json';
// export {default as SkipToMain} from '@/components/SkipToMain/locales.json';
export { default as StickyContainer } from '@/components/StickyContainer/locales.json';
// export {default as VerifyPhoneWrapper} from '@/components/VerifyPhoneWrapper/locales.json';
export { default as LayoutsLocales } from '@/layouts/locales.json';
export { default as AlertAndNotification } from '@/modules/AlertAndNotification/locales.json';

export { default as ChildriderLocales } from '@/modules/childrider/locales.json';
export { default as ChildriderCRCStepAPersonalInfo } from '@/modules/childrider/components/CRCStepAPersonalInfo/locales.json';
export { default as ChildriderCRCStepBSelectionOptions } from '@/modules/childrider/components/CRCStepBSelectionOptions/locales.json';
export { default as ChildriderCRCStepCConfirmPayment } from '@/modules/childrider/components/CRCStepCConfirmPayment/locales.json';
export { default as ChildriderCRCStepDEDelivery } from '@/modules/childrider/components/CRCStepDEDelivery/locales.json';
export { default as ChildriderCRCStepEAcknowledge } from '@/modules/childrider/components/CRCStepEAcknowledge/locales.json';

export { default as DebtSolutions } from '@/modules/debtsolutions/locales.json';

// export {default as Documents} from '@/modules/documents/locales.json';

export { default as Error } from '@/modules/error/locales.json';

export { default as HomeDashboard } from '@/modules/home/dashboard/locales.json';
// export {default as HomeDashboardPrePurchaseLifeCard} from '@/modules/home/dashboard/components/TermLife/components/PrePurchaseLifeCard/locales.json';
// export {default as HomeDashboardTerminatedPolicy} from '@/modules/home/dashboard/components/TermLife/components/TerminatedPolicy/locales.json';
// export {default as HomeDashboardTermLifeCard} from '@/modules/home/dashboard/components/TermLife/components/TermLifeCard/locales.json';

export { default as HomeDomesticviolence } from '@/modules/home/domesticviolence/locales.json';
export { default as HomeMyaccount } from '@/modules/home/myaccount/components/locales.json';
export { default as Investments } from '@/modules/investments/locales.json';
export { default as Login } from '@/modules/login/locales.json';
export { default as LoginLandingPage } from '@/modules/login/loginLandingPage/locales.json';
export { default as LoginPostLoginBiometrics } from '@/modules/bootstrapTasks/biometrics/locales.json';
export { default as LoginPostLoginPolicyacknowledgement } from '@/modules/bootstrapTasks/policyacknowledgement/locales.json';
export { default as LoginPostLoginTermsofuse } from '@/modules/bootstrapTasks/termsofuse/locales.json';
export { default as LoginPreLoginAppupdate } from '@/modules/login/preLogin/appupdate/locales.json';
export { default as LoginPreLoginMaintenance } from '@/modules/login/preLogin/maintenance/locales.json';
export { default as LoginPreLoginUnsupportedbrowser } from '@/modules/login/preLogin/unsupportedbrowser/locales.json';

export { default as PolicycomponentsPaymentMethod } from '@/modules/policy/components/PaymentMethod/locales.json';
export { default as PolicycomponentsPaymentMethodComponents } from '@/modules/policy/components/PaymentMethod/components/locales.json';
export { default as PolicycomponentsUpdateBeneficiaries } from '@/modules/policy/components/UpdateBeneficiaries/locales.json';
export { default as PolicycomponentsWithDrawalDate } from '@/modules/policy/components/WithDrawalDate/locales.json';
export { default as PolicyPolicyGuidanceCalculator } from '@/modules/policy/PolicyGuidanceCalculator/locales.json';
export { default as PolicyPolicyLearnMore } from '@/modules/policy/PolicyLearnMore/locales.json';
export { default as PolicyPolicyMyPolicy } from '@/modules/policy/PolicyMyPolicy/locales.json';
export { default as PolicyPolicyMyPolicyAnnuities } from '@/modules/policy/PolicyMyPolicy/components/Annuities/locales.json';
export { default as PolicyPolicyMyPolicyBeneficiaries } from '@/modules/policy/PolicyMyPolicy/components/Beneficiaries/locales.json';
export { default as PolicyPolicyMyPolicyPaymentInformation } from '@/modules/policy/PolicyMyPolicy/components/PaymentInformation/locales.json';
export { default as PolicyPolicyMyPolicyPolicyOverview } from '@/modules/policy/PolicyMyPolicy/components/PolicyOverview/locales.json';
export { default as PolicyPolicyMyPolicyPolicyOwner } from '@/modules/policy/PolicyMyPolicy/components/PolicyOwner/locales.json';
export { default as PolicyPolicyMyPolicyPolicyOwnerPayMethod } from '@/modules/policy/PolicyMyPolicy/components/PayMethod/locales.json';
export { default as PolicyPolicyMyPolicyPolicyOwnerPaymentInfo2 } from '@/modules/policy/PolicyMyPolicy/components/PaymentInfo2/locales.json';

export { default as Reinstatement } from '@/modules/Reinstatement/locales.json';
export { default as ReinstatementComponents } from '@/modules/Reinstatement/components/locales.json';
export { default as MinorAccountLinkProcess } from '@/modules/minorAccountLinkProcess/locales.json';

import Root_en_US from '@/locales/en_US.json';
import Root_es_US from '@/locales/es_US.json';
import Root_en_CA from '@/locales/en_CA.json';
import Root_fr_CA from '@/locales/fr_CA.json';

export const Root = {
  en_US: Root_en_US,
  es_US: Root_es_US,
  en_CA: Root_en_CA,
  fr_CA: Root_fr_CA,
};

/* export const en_US = {
  ...Footer.en_US,
  ...Header.en_US,
  ...TermsOfUse.en_US,
  ...NavigationDrawer.en_US,
  ...Dashboard.en_US,
  ...DebtSolutionsCard.en_US,
  ...ChildRider.en_US,
  ...PolicyMyRep.en_US,
};

export const es_US = {
  ...Footer.es_US,
  ...Header.es_US,
  ...TermsOfUse.es_US,
  ...NavigationDrawer.es_US,
  ...Dashboard.es_US,
  ...DebtSolutionsCard.es_US,
  ...ChildRider.es_US,
  ...PolicyMyRep.es_US,
};

export const en_CA = {
  ...Footer.en_CA,
  ...Header.en_CA,
  ...TermsOfUse.en_CA,
  ...NavigationDrawer.en_CA,
  ...Dashboard.en_CA,
  ...DebtSolutionsCard.en_CA,
  ...ChildRider.en_CA,
  ...PolicyMyRep.en_CA,
};

export const fr_CA = {
  ...Footer.fr_CA,
  ...Header.fr_CA,
  ...TermsOfUse.fr_CA,
  ...NavigationDrawer.fr_CA,
  ...Dashboard.fr_CA,
  ...DebtSolutionsCard.fr_CA,
  ...ChildRider.fr_CA,
  ...PolicyMyRep.fr_CA,
};
 */
